import { render, staticRenderFns } from "./Ikas.vue?vue&type=template&id=db7cb6ce&scoped=true"
import script from "./Ikas.vue?vue&type=script&lang=js"
export * from "./Ikas.vue?vue&type=script&lang=js"
import style0 from "./Ikas.vue?vue&type=style&index=0&id=db7cb6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7cb6ce",
  null
  
)

export default component.exports